angular.module('GlobalHelpersModule').filter 'formatDateUtc', ->
  (date, format) ->
    if not format?
      format = 'MM/DD/YYYY'
    if date? and date.toString().length > 0
      moment.utc(date).format(format)
    else
      ''
